import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'auth/';

class AuthService {
    login(user) {
        return axios
            .post(API_URL + 'signin', {
                email: user.email,
                password: user.password
            })
            .then(res => {
                if (res.data.user.token) {
                    localStorage.setItem('user', JSON.stringify(res.data.user));
                }
                return res.data;
            })
    }
    logout() {
        return axios.get(API_URL + 'logout', {headers: authHeader() }).then(res => {
            if (res) {
                localStorage.removeItem('user');
            }
        }); 
    }
    register(user) {
        return axios.post(API_URL + 'signup', {
            email: user.email,
            password: user.password,
            firstName: user.firstName,
            lastName: user.lastName,
            roles: user.roles,
            payCode: user.payCode,
            isEnterprise: user.isEnterprise,
            organizationName: user.organizationName
        })
    }
    forgot(email) {
        return axios
            .post(API_URL + 'forgot', {
                email: email
            })
    }
    reset(token, password) {
        return axios
            .post(API_URL + 'reset/' + token, {
                password: password
            })
    }
}

export default new AuthService();